/*=========================================================================================
  File Name: module-supplier.js
  Description: Supplier Module
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-supplier-state';
import mutations from './module-supplier-mutations';
import actions from './module-supplier-actions';
import getters from './module-supplier-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
